import { ChevronDown, MoreHorizontal, Loader2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { btnGhost } from "@/lib/studioApi";

/* « Plus d'actions ▾ » : regroupe les actions secondaires d'un document. items: [{ id, label, icon, onClick, disabled, busy, danger, separator }] */
export const MoreActionsMenu = ({ items, label = "Plus d'actions", testId = "more-actions", className = "" }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <button type="button" data-testid={testId} className={`${btnGhost} whitespace-nowrap px-3 ${className}`}>
        <MoreHorizontal className="h-4 w-4 text-[#5C6A87]" /> <span className="sm:hidden">Plus</span><span className="hidden sm:inline">{label}</span> <ChevronDown className="h-3.5 w-3.5 text-[#93A0BC]" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" sideOffset={6} className="w-64 rounded-xl border-[#E2E7F7] p-1.5 shadow-[0_20px_50px_-20px_rgba(15,38,69,0.35)]">
      {items.filter(Boolean).map((it) =>
        it.separator ? (
          <DropdownMenuSeparator key={it.id} className="my-1 bg-[#E2E7F7]" />
        ) : (
          <DropdownMenuItem
            key={it.id}
            data-testid={it.testId || `${testId}-${it.id}`}
            disabled={it.disabled || it.busy}
            onSelect={() => it.onClick?.()}
            className={`flex cursor-pointer items-center gap-2.5 rounded-lg px-2.5 py-2.5 text-sm font-medium focus:bg-[#F6F8FD] ${it.danger ? "text-rose-700 focus:text-rose-700" : "text-[#0F2645]"}`}
          >
            {it.busy ? <Loader2 className="h-4 w-4 animate-spin" /> : it.icon && <it.icon className={`h-4 w-4 ${it.danger ? "text-rose-600" : "text-[#3A5CC8]"}`} />}
            <span className="flex-1">{it.label}</span>
            {it.hint && <span className="text-[11px] text-[#93A0BC]">{it.hint}</span>}
          </DropdownMenuItem>
        ),
      )}
    </DropdownMenuContent>
  </DropdownMenu>
);
